<template>
  <div class="container my-1">
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <div id="categoryContentBreadcrums" class="row breadcrumbs">
        <div class="col-12 col-md-7 font-be-vietnam">
          <ul class="breadcrumbs d-flex align-items-center pl-1">
            <li style="">
              <router-link :to="{ name: 'home' }">
                <feather-icon icon="HomeIcon" width="18px" height="18px" />
              </router-link>
            </li>
            <span v-if="category.slug" class="icon" />
            <li v-if="category.slug">
              <router-link :title="category.name"
                :to="{ name: $route.name, params: { slug: category.slug, id: category.id } }" style=" "
                class="font-weight-600 li_item"> {{ category.name }}</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="postlist mt-1">
        <div class="filter p-1">
          <div class="row breadcrumb_category_child">
            <div class="col-12 col-md-8">
              <ul v-if="dataCategory.length" class="flex-wrap">
                <li v-for="(item, index) in dataCategory" :key="index" :class="(category.id == item.id) ? 'active' : ''">
                  <router-link :title="item.name" :to="{ name: $route.name, params: { slug: item.slug, id: item.id } }">
                    {{ item.name }}</router-link>
                </li>
              </ul>
            </div>
            <div class="col-12 col-md-4 mt-xs-2 pr-1">
              <div class="d-flex flex-row justify-content-end algin-items-center">
                <b-button variant="blue" @click="refreshData(currentSlug)">
                  <feather-icon icon="RepeatIcon" /> Làm mới</b-button>
              </div>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-6 col-12">
              <b-form-group label="Tiêu đề" class="font-weight-bolder mb-0">
                <b-form-input v-model="localSearchQuery" placeholder="Tiêu đề" @keyup.enter="updateSearchQuery" />

              </b-form-group>
            </div>
            <div class="col-12 col-md-5 mt-xs-1">
              <b-form-group label="Khoảng thời gian đăng" class="font-weight-bolder mb-0">
                <div class="input-group">
                  <flat-pickr v-model="bookDate" :value="bookDate" class="form-control" :config="configDateRange"
                    placeholder="dd/mm/yyyy - dd/mm/yyyy" />
                  <div class="input-group-append">
                    <button class="btn btn-default mt-0" style="border-color: #d8d6de;" type="button" title="Xóa"
                      data-clear>
                      <feather-icon icon="XIcon" />
                    </button>
                  </div>
                </div>
              </b-form-group>
            </div>
            <div class="col-12 col-md-1 p-0">
              <b-button variant="gradient-danger" class="d-flex" @click="updateSearchQuery"><feather-icon
                  icon="SearchIcon" />&nbsp;&nbsp;Tìm kiếm </b-button>
            </div>
          </div>
        </div>

        <div class="card border-0">
          <div class="card-body p-1">
            <!-- Pagination -->
            <b-row class="mb-1">
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <span class="text-dark font-weight-600">{{ $t('show_to_entries', {
                  from: dataMeta.from, to: dataMeta.to,
                  of: dataMeta.of
                }) }}</span>
              </b-col>
              <b-col v-if="total" cols="12" sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end">
                <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" :limit="8" first-number
                  last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>

            <!-- LIST VIEW -->
            <div class="home_post_list">
              <div v-for="(item, index) in itemsData" :key="index" class="card-body p-1 mb-1 d-flex card_body_item">
                <div class="w-15 d-none d-sm-flex align-items-center">
                  <span class="iconClock mr-5px" />
                  <span class=" text-center text-dark-2 font-size14-be-vietnam font-weight-600 line-height-20">{{
                    item.published_at }}</span>
                </div>
                <div class="w-85">
                  <router-link :to="{ name: 'home-view-propate-box', params: { id: item.id, slug: item.slug } }"
                    class="link" event @click.native.prevent="openPreviewModal(item)">
                    <div class=" text-wrap text-dark-1 font-size14-be-vietnam ">
                      <span class="text-dark-1 font-size14-be-vietnam font-weight-600 line-height-20">{{ item.title }}
                        <span><feather-icon icon="PaperclipIcon" /></span>
                      </span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <!-- Pagination -->
            <b-row class="mt-1">
              <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
                <span class="text-dark font-weight-600">{{ $t('show_to_entries', {
                  from: dataMeta.from, to: dataMeta.to,
                  of: dataMeta.of
                }) }}</span>
              </b-col>
              <b-col v-if="total" cols="12" sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end">
                <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" :limit="8" first-number
                  last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-overlay>
    <!-- MODAL PREVIEW -->
    <ViewPopup :show-preview="showPreview" :article-id="articleId" @close="onPreviewHidden"
      @on-view-article="onViewArticle" @on-read-article="onReadArticle" />
  </div>
</template>
<script>
import {
  BOverlay,
  BRow,
  BCol,
  BButton,
  BPagination,
  BFormInput,
  BFormGroup,
  VBTooltip,
} from 'bootstrap-vue';
import {
  ref, watch, onMounted, onBeforeUnmount,
} from '@vue/composition-api';
import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import moment from 'moment';
import Ripple from 'vue-ripple-directive';
import { useRouter } from '@/@core/utils/utils';
import useCategory from './useCategory';

export default {
  components: {
    BOverlay,
    BRow,
    BCol,
    BButton,
    BPagination,
    BFormInput,
    BFormGroup,
    flatPickr,
    ViewPopup: () => import(/* webpackPrefetch: true */ './ViewPopup.vue'),
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      dataParent: [],
      moment,
    }
  },
  computed: {
  },
  watch: {
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const {
      loading,
      perPage,
      total,
      dataMeta,
      allowResetCurrentPage,
      allowRefetchPaginate,
      currentPage,
      searchQuery,
      localSearchQuery,
      itemsData,
      dataArticleType,
      department_id,
      bookDate,
      article_type,
      refListTable,
      dataDepartment,
      currentSlug,
      dataCategory,
      category,
      resultData,
      showMode,
      classShowMode,
      Imgsize,
      tableColumns,
      updateSearchQuery,
      fetchAll,
      onWindowScroll,
      articleId,
      articleData,
      showPreview,
      onViewArticle,
      onReadArticle,
    } = useCategory(context);

    // overide old setup
    Vietnamese.rangeSeparator = ' - ';
    const configDateRange = ref({
      dateFormat: 'd/m/Y',
      mode: 'range',
      wrap: true,
      showMonths: 2,
      locale: Vietnamese, // locale for this instance only
    });

    perPage.value = 30

    const openPreviewModal = (item) => {
      articleId.value = item.id
      articleData.value = item
      showPreview.value = true
    }
    const onPreviewHidden = () => {
      showPreview.value = false
      articleData.value = null
    }

    watch(
      () => route.value.params.slug,
      (newSlug, oldSlug) => {
        currentPage.value = 1
        bookDate.value = ''
        localSearchQuery.value = ''
        searchQuery.value = ''
        currentSlug.value = newSlug
        allowRefetchPaginate.value = true
        // console.log('watch slug change', oldSlug, newSlug, 'currentSlug.value', currentSlug.value);
        fetchAll();
      },
    )

    watch([searchQuery, bookDate], () => {
      //console.log('allowResetCurrentPage.value', allowResetCurrentPage.value);
      if (allowResetCurrentPage.value) {
        currentPage.value = 1
      }
      allowRefetchPaginate.value = true
      // console.log('loading.value', loading.value);
      if (!loading.value) {
        fetchAll();
      }
    });

    watch([currentPage], (newPage) => {
      // console.log('watch currentpage', newPage);
      if (!loading.value) {
        fetchAll();
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    });

    onMounted(() => {
      // console.log('onmouted', route.value);
      let dataCache = window.localStorage.getItem('VOVAT-route-category')
      dataCache = dataCache ? JSON.parse(dataCache) : null
      // console.log('dataCache: ', dataCache);
      if (dataCache && dataCache.path === route.value.path) {
        // console.log('dataCache.path === route.value.path', dataCache.path === route.value.path);
        currentSlug.value = dataCache.params.slug
        currentPage.value = dataCache.query.currentPage
        searchQuery.value = dataCache.query.searchQuery
        localSearchQuery.value = dataCache.query.searchQuery
        bookDate.value = dataCache.query.bookDate
        setTimeout(() => {
          allowResetCurrentPage.value = true
          // console.log('reset allowResetCurrentPage', allowResetCurrentPage.value);
        }, 0);
        loading.value = false
        fetchAll()
      } else {
        currentSlug.value = route.value.params.slug
        fetchAll()
      }

      window.addEventListener('scroll', onWindowScroll)
    });

    onBeforeUnmount(() => {
      // console.log('onbeforeunmoundted', route.value);
      const dataCache = {
        path: route.value.path,
        name: route.value.name,
        params: route.value.params,
        query: {
          currentPage: currentPage.value,
          searchQuery: searchQuery.value,
          bookDate: bookDate.value,
        },
      }
      // console.log('dataCache', dataCache);
      window.localStorage.setItem('VOVAT-route-category', JSON.stringify(dataCache))

      window.removeEventListener('scroll', onWindowScroll);
    });

    return {
      articleId,
      openPreviewModal,
      showPreview,
      onPreviewHidden,
      tableColumns,
      dataMeta,
      itemsData,
      currentPage,
      perPage,
      loading,
      article_type,
      dataDepartment,
      refListTable,
      localSearchQuery,
      dataArticleType,
      total,
      department_id,
      updateSearchQuery,
      dataCategory,
      currentSlug,
      category,
      showMode,
      classShowMode,
      resultData,
      configDateRange,
      bookDate,
      Imgsize,
      onViewArticle,
      onReadArticle,
    }
  },
  methods: {

  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
